import { render } from "./Pay.vue?vue&type=template&id=4472f927"
import script from "./Pay.js?vue&type=script&lang=js"
export * from "./Pay.js?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./Pay.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Firshadck%2Fprojects%2Fsunrise-spa%2Fsrc%2Fpresentation%2Ffashion%2FPay%2FPay.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/Users/irshadck/projects/sunrise-spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__